import React from 'react';
import Layout from '../Layout';
import { Typography, Container, Box } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import SelectAssetComponent from '../SelectAsset';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';

const PLISelectAsset = () => {
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const handleAssetSelection = (asset) => {
        console.log("Asset:", asset);
        // navigate(`/pli-form/${asset?.Asset_no || asset?.asset_no}`)
        navigate(`/pli-history/${asset?.Asset_no || asset?.asset_no}`)
    };




    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        PLI Physical Verification
                    </Typography>
                </Box> */}
                <Box mt={1} mb={1}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Select Asset" />
                </Box>
                <SelectAssetComponent handleAssetSelection={handleAssetSelection} title="Select Asset for PLI Physical Verification" pli={true} />

            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default PLISelectAsset;
